/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";
import { useTheme } from "../../../../config/emotion";

import EwaButton2 from "./EwaButton/EwaButton2";
import { PurposedButtonProps } from "./types";
import { labellessButtonCss } from "./styles";

const CopyButton = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      dataCy="copy-button"
      buttonColor={colors.secondaryColor}
      tooltip={formatMessage({ id: "common.copy" })}
      iconName="file_copy"
      css={labellessButtonCss}
      {...props}
    />
  );
};

export default CopyButton;
